import React, { useState } from 'react';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';
import ContactAgentModal from '../components/ContactAgentModal/ContactAgentModal';
import { LocationIcon, HomeIcon, PhoneIcon, EmailIcon, FilterIcon } from '../components/Icons/Icons';
import './Agents.css';

function Agents() {
  const [selectedCity, setSelectedCity] = useState('all');
  const [selectedSpecialty, setSelectedSpecialty] = useState('all');
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const cities = ['All Cities', 'Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad'];
  const specialties = ['All Specialties', 'Buy', 'Rent', 'Commercial', 'Projects'];

  // Mock agents data
  const agentsData = [
    {
      id: 1,
      name: 'Ahmed Khan',
      designation: 'Senior Property Consultant',
      city: 'Karachi',
      specialty: 'Buy',
      experience: '8 years',
      properties: 245,
      rating: 4.9,
      reviews: 156,
      phone: '+92 300 1234567',
      email: 'ahmed.khan@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=12',
      verified: true,
      languages: ['English', 'Urdu', 'Sindhi']
    },
    {
      id: 2,
      name: 'Fatima Ali',
      designation: 'Real Estate Expert',
      city: 'Lahore',
      specialty: 'Rent',
      experience: '6 years',
      properties: 189,
      rating: 4.8,
      reviews: 142,
      phone: '+92 321 9876543',
      email: 'fatima.ali@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=45',
      verified: true,
      languages: ['English', 'Urdu', 'Punjabi']
    },
    {
      id: 3,
      name: 'Bilal Ahmed',
      designation: 'Commercial Property Specialist',
      city: 'Islamabad',
      specialty: 'Commercial',
      experience: '10 years',
      properties: 312,
      rating: 5.0,
      reviews: 203,
      phone: '+92 333 5551234',
      email: 'bilal.ahmed@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=33',
      verified: true,
      languages: ['English', 'Urdu']
    },
    {
      id: 4,
      name: 'Sara Malik',
      designation: 'Property Consultant',
      city: 'Karachi',
      specialty: 'Projects',
      experience: '5 years',
      properties: 167,
      rating: 4.7,
      reviews: 98,
      phone: '+92 345 7778888',
      email: 'sara.malik@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=47',
      verified: true,
      languages: ['English', 'Urdu']
    },
    {
      id: 5,
      name: 'Hassan Raza',
      designation: 'Real Estate Advisor',
      city: 'Lahore',
      specialty: 'Buy',
      experience: '7 years',
      properties: 221,
      rating: 4.9,
      reviews: 178,
      phone: '+92 300 4445566',
      email: 'hassan.raza@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=15',
      verified: true,
      languages: ['English', 'Urdu', 'Punjabi']
    },
    {
      id: 6,
      name: 'Ayesha Tariq',
      designation: 'Senior Real Estate Consultant',
      city: 'Islamabad',
      specialty: 'Rent',
      experience: '9 years',
      properties: 278,
      rating: 4.8,
      reviews: 189,
      phone: '+92 321 2223344',
      email: 'ayesha.tariq@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=48',
      verified: true,
      languages: ['English', 'Urdu']
    },
    {
      id: 7,
      name: 'Usman Shahid',
      designation: 'Property Investment Advisor',
      city: 'Rawalpindi',
      specialty: 'Projects',
      experience: '6 years',
      properties: 195,
      rating: 4.7,
      reviews: 132,
      phone: '+92 333 9998877',
      email: 'usman.shahid@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=51',
      verified: true,
      languages: ['English', 'Urdu']
    },
    {
      id: 8,
      name: 'Maria Khan',
      designation: 'Commercial Real Estate Expert',
      city: 'Faisalabad',
      specialty: 'Commercial',
      experience: '8 years',
      properties: 234,
      rating: 4.9,
      reviews: 167,
      phone: '+92 300 6667788',
      email: 'maria.khan@pakmilkiyat.com',
      image: 'https://i.pravatar.cc/300?img=49',
      verified: true,
      languages: ['English', 'Urdu', 'Punjabi']
    }
  ];

  const filteredAgents = agentsData.filter(agent => {
    const cityMatch = selectedCity === 'all' || agent.city === selectedCity;
    const specialtyMatch = selectedSpecialty === 'all' || agent.specialty === selectedSpecialty;
    return cityMatch && specialtyMatch;
  });

  const topAgents = agentsData.filter(a => a.rating >= 4.9).slice(0, 3);

  const handleContactAgent = (agentId) => {
    const agent = agentsData.find(a => a.id === agentId);
    if (agent) {
      setSelectedAgent(agent);
      setIsModalOpen(true);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedAgent(null), 300);
  };

  return (
    <div className="agents-page">
      <Header />

      <div className="agents-container">
        <div className="agents-hero">
          <div className="agents-hero-content">
            <h1>Find Expert Real Estate Agents</h1>
            <p>Connect with verified property consultants across Pakistan</p>
          </div>
        </div>

        <div className="agents-content">
          <div className="agents-filter-bar">
            <div className="agents-filter-content">
              <div className="agent-filter-item">
                <label className="agent-filter-label">City</label>
                <select
                  value={selectedCity}
                  onChange={(e) => setSelectedCity(e.target.value)}
                  className="agent-filter-select"
                >
                  {cities.map((city, index) => (
                    <option key={index} value={index === 0 ? 'all' : city}>
                      {city}
                    </option>
                  ))}
                </select>
              </div>

              <div className="agent-filter-item">
                <label className="agent-filter-label">Specialty</label>
                <select
                  value={selectedSpecialty}
                  onChange={(e) => setSelectedSpecialty(e.target.value)}
                  className="agent-filter-select"
                >
                  {specialties.map((specialty, index) => (
                    <option key={index} value={index === 0 ? 'all' : specialty}>
                      {specialty}
                    </option>
                  ))}
                </select>
              </div>

              <div className="agent-filter-results">
                <FilterIcon size={20} color="#636e72" />
                <span>{filteredAgents.length} agents available</span>
              </div>
            </div>
          </div>

          <section className="top-agents-section">
            <h2 className="agents-section-title">Top Rated Agents</h2>
            <div className="top-agents-grid">
              {topAgents.map(agent => (
                <div key={agent.id} className="top-agent-card">
                  <div className="top-agent-header">
                    <div className="top-agent-image">
                      <img src={agent.image} alt={agent.name} />
                      {agent.verified && <div className="verified-badge">✓</div>}
                    </div>
                    <div className="top-agent-rating">
                      <span className="rating-star">★</span>
                      <span className="rating-value">{agent.rating}</span>
                      <span className="rating-reviews">({agent.reviews})</span>
                    </div>
                  </div>
                  <div className="top-agent-info">
                    <h3 className="top-agent-name">{agent.name}</h3>
                    <p className="top-agent-designation">{agent.designation}</p>
                    <div className="top-agent-stats">
                      <div className="agent-stat">
                        <span className="stat-value">{agent.properties}</span>
                        <span className="stat-label">Properties</span>
                      </div>
                      <div className="agent-stat">
                        <span className="stat-value">{agent.experience}</span>
                        <span className="stat-label">Experience</span>
                      </div>
                    </div>
                    <div className="top-agent-location">
                      <LocationIcon size={14} color="#636e72" />
                      <span>{agent.city}</span>
                    </div>
                    <div className="top-agent-languages">
                      {agent.languages.map((lang, index) => (
                        <span key={index} className="language-tag">{lang}</span>
                      ))}
                    </div>
                    <button
                      className="btn-contact-top"
                      onClick={() => handleContactAgent(agent.id)}
                    >
                      Contact Agent
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="all-agents-section">
            <h2 className="agents-section-title">All Agents</h2>
            <div className="agents-grid">
              {filteredAgents.map(agent => (
                <div key={agent.id} className="agent-card">
                  <div className="agent-card-header">
                    <div className="agent-avatar">
                      <img src={agent.image} alt={agent.name} />
                      {agent.verified && <div className="agent-verified-badge">✓</div>}
                    </div>
                    <div className="agent-rating-info">
                      <div className="agent-rating-stars">
                        <span className="agent-star">★</span>
                        <span className="agent-rating-num">{agent.rating}</span>
                      </div>
                      <div className="agent-review-count">{agent.reviews} reviews</div>
                    </div>
                  </div>
                  <div className="agent-card-body">
                    <h3 className="agent-card-name">{agent.name}</h3>
                    <p className="agent-card-designation">{agent.designation}</p>
                    <div className="agent-specialty-badge">{agent.specialty}</div>
                    <div className="agent-metrics">
                      <div className="metric-item">
                        <HomeIcon size={16} color="#636e72" />
                        <span>{agent.properties} properties</span>
                      </div>
                      <div className="metric-item">
                        <LocationIcon size={16} color="#636e72" />
                        <span>{agent.city}</span>
                      </div>
                    </div>
                    <div className="agent-contact-info">
                      <div className="contact-item">
                        <PhoneIcon size={14} color="#636e72" />
                        <span>{agent.phone}</span>
                      </div>
                      <div className="contact-item">
                        <EmailIcon size={14} color="#636e72" />
                        <span>{agent.email}</span>
                      </div>
                    </div>
                    <button
                      className="btn-contact-agent"
                      onClick={() => handleContactAgent(agent.id)}
                    >
                      Contact Agent
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="become-agent-section">
            <div className="become-agent-content">
              <h2>Become a PakMilkiyat Agent</h2>
              <p>Join our network of professional real estate consultants and grow your business</p>
              <button className="btn-become-agent" onClick={() => window.navigateTo && window.navigateTo('contact')}>
                Apply Now
              </button>
            </div>
          </section>
        </div>
      </div>

      <Footer />

      <ContactAgentModal
        agent={selectedAgent}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
      />
    </div>
  );
}

export default Agents;
